import type { FriendRequestResponse, FriendsOverview, PlayerId } from '@pixelworld/shared';
import { api } from '../../lib/api';

const path = (playerId: PlayerId) => encodeURIComponent(playerId);

export const fetchFriends = () => api<FriendsOverview>('GET', '/friends');

export const askToBeFriends = (playerId: PlayerId) =>
  api<FriendRequestResponse>('POST', '/friends/requests', { playerId });

export const answerFriendRequest = (playerId: PlayerId, accept: boolean) =>
  api<{ outcome: string }>('POST', `/friends/requests/${path(playerId)}`, { accept });

export const removeFriend = (playerId: PlayerId) =>
  api<{ ok: true }>('POST', `/friends/${path(playerId)}/remove`);

export type InviteResponse =
  { ok: true } | { ok: false; error: 'NOT_FRIENDS' | 'TOO_SOON' | 'NOT_IN_ROOM' };

/** "Kom og spil": asks a friend to come to the player's room. */
export const inviteFriend = (playerId: PlayerId) =>
  api<InviteResponse>('POST', `/friends/${path(playerId)}/invite`);

export const dismissInvite = (playerId: PlayerId) =>
  api<{ ok: true }>('POST', `/friends/invites/${path(playerId)}/dismiss`);
